import React, { useState, useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
// import axios from 'axios'
import { formatDateFit } from '../buyer/BuyerRequestDetails'
import {
  CommonReasonTextarea,
  DatefilterFn,
  ValidateAPI,
  convertToLocalDate,
  handleAcceptExpediteDeferRequests,
  handlePODetailsClick,
  handleRejectExpediteDeferDivertRequest,
  reasonCodesEN,
  reasonCodesMN
} from '../../utils/Utils'
import ConfirmTable from '../../components/ConfirmTable'
import Loading from '../../components/Loading'
import { EditedRowState } from '../../LineContext/Context'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import PopupModal from '../../components/PopupModal'
import PopupBanner from '../../components/PopupBanner'
import ReasonCodeList, { ReasonCodeView } from '../../components/ReasonCodeList'
import axiosInstance from '../../api/axiosInstance'
import { CartState } from '../../Context/Context'

const Divert = () => {
  const [requestData, setRequestData] = useState([])
  const user = JSON.parse(localStorage.getItem('userData'))
  const [loading, setLoading] = useState(false)
  const [selectedRowArray, setSelectedRowArray] = useState([])
  const navigate = useNavigate()
  const [showRejectModal, setShowRejectModal] = useState(false)
  const [reasonCodeValue, setreasonCodeValue] = useState({
    "reasonCodeId": "",
    "reasonCodeText": ""
  })
  const [submitting, setSubmitting] = useState(false)
  const [rowSelection, setRowSelection] = useState({})
  const [showDivertAcceptModal, setShowDivertAcceptModal] = useState(false)
  const [showChangeRequestBanner, setShowChangeRequestBanner] = useState(false)
  const [showRejectRequestBanner, setShowRejectRequestBanner] = useState(false)
  const [poRow, setPoRow] = useState('')
  const [crIdResponse, setCrIdResponse] = useState('')
  const [editCrIdResponse, setEditCrIdResponse] = useState('')
  const [editPoRow, setEditPORow] = useState('')
  const { t } = useTranslation()
  const [validSw, setValidSw] = useState(false)
  const tableId = 'Divertable' // Define tableId here
  const { updateDataCount } = CartState()
  const [errorMessage, setErrorMessage] = useState('')
  const {
    DivertRequests,
    Home,
    Submitting_Load,
    Pleaseselectreasoncodeforrejectingtheorder,
    Selectareason,
    PleaseSelectaPO,
    Reject,
    Cancel
  } = t('DivertPage')
  const {
    state: { editArray },
    dispatch
  } = EditedRowState()

  // Access translated strings outside useMemo
  const headers = {
    CR: t('DivertPage.CR'),
    PONUMBER: t('DivertPage.PONUMBER'),
    SKU: t('DivertPage.SKU'),
    UPC: t('DivertPage.UPC'),
    STATUS: t('DivertPage.STATUS'),
    REQUESTTYPE: t('DivertPage.REQUESTTYPE'),
    REQUESTEDBY: t('DivertPage.REQUESTEDBY'),
    CREATEDATE: t('DivertPage.CREATEDATE'),
    UPDATEDATE: t('DivertPage.UPDATEDATE'),
    CRSTATUS: t('DivertPage.CRSTATUS'),
    VENDORRESPONSE: t('DivertPage.VENDORRESPONSE'),
    // REQSW: t('DivertPage.REQSW'),
    CHANGEDSW: t('POList.CHANGEDSW'),
    CURRENTSW: t('DivertPage.CURRENTSW'),
    ORGSW: t('ConfirmPOpage.ORGSW'),
    DC: t('DivertPage.DC'),
    REQDC: t('DivertPage.REQDC')
  }
  const columns = useMemo(
    () => [
      {
        header: headers.CR,
        accessorKey: 'id_open_request',
        cell: ({ row }) =>
          row?.original?.request_type === 'URGENT' ? (
            <p
              className='underline cursor-pointer text-blue-500'
              onClick={() =>
                navigate(
                  `/vendor/urgent_orders/request_details/${row?.original.id_open_request}`,
                  { state: row?.original }
                )
              }
            >
              {row?.original?.id_open_request}
            </p>
          ) : (
            <p
              className='underline cursor-pointer text-blue-500'
              onClick={() =>
                navigate(
                  `/vendor/po_change_requests/request_details/${row?.original.id_open_request}`,
                  { state: row?.original }
                )
              }
            >
              {row?.original?.id_open_request}
            </p>
          ),
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        },
      },
      {
        header: headers.PONUMBER,
        accessorKey: 'po_number',
        cell: (info) => {
          return (
            <p
              className='underline cursor-pointer text-blue-500'
              onClick={() => handlePODetailsClick('vendor', info?.getValue())}
            >
              {info?.getValue()}
            </p>
          )
        },
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        },
      },
      {
        header: headers.SKU,
        accessorKey: 'sku',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        },
      },
      {
        header: headers.UPC,
        accessorKey: 'upc',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        }
      },
      {
        header: headers.DC,
        accessorKey: 'original_dc',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        },
      },
      {
        header: headers.REQDC,
        accessorKey: 'requested_dc',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        },
      },
      // { header: headers.CHANGEDSW, accessorKey: 'requested_ship_week' },
      {
        header: headers.ORGSW,
        accessorKey: 'original_ship_week',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        }
      },
      {
        header: headers.CURRENTSW,
        accessorKey: 'current_ship_week',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        },
      },
      {
        header: headers.VENDORRESPONSE,
        accessorFn: row => {
          const value = row?.supplier_response;

          if (value == null || String(value).trim() === '') {
            return 'BLANK';
          }

          return value.toUpperCase() === 'REJECTED'
            ? 'Acknowledged PO with exceptions'
            : value;
        },
        cell: ({ row }) => {
          const value = row?.original?.supplier_response;

          if (value == null || String(value).trim() === '') {
            return null;
          }

          return (
            <span>
              {value.toUpperCase() === 'REJECTED'
                ? 'Acknowledged PO with exceptions'
                : value}
            </span>
          );
        },

        filterFn: (row, id, filterValue) => {
          const cellValue = row.getValue(id);

          if (!cellValue || !filterValue) return false;

          const selectedValues = String(filterValue)
            .split(",")
            .map(value => value.trim().toLowerCase());

          return selectedValues.includes(
            String(cellValue).trim().toLowerCase()
          );
        }
      },
      {
        header: headers.CRSTATUS,
        accessorKey: 'status',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        },
      },
      {
        header: headers.REQUESTTYPE,
        accessorKey: 'request_type',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        },
      },
      {
        header: headers.REQUESTEDBY,
        accessorKey: 'created_by',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        },
      },
      {
        header: headers.CREATEDATE,
        accessorKey: 'created_at',
        cell: (info) =>
          info?.getValue() !== null ? convertToLocalDate(info?.getValue()) : '',
        filterFn: DatefilterFn
      }
      // {
      //   header: headers.UPDATEDATE,
      //   accessorKey: 'updated_at',
      //   cell: (info) =>
      //     info?.getValue() !== null ? formatDateFit(info?.getValue()) : ''
      // },
    ],
    [headers]
  )

  const closeDivertAcceptModal = () => {
    setShowDivertAcceptModal(false)
  }

  const openDivertAcceptModal = () => {
    setShowDivertAcceptModal(true)
  }
  const closePopUpModal = () => {
    // setPoRow(false)
    setShowRejectRequestBanner(false)
    setShowChangeRequestBanner(false)
  }

  // const handleAcceptRequest = () => {
  //   setSubmitting(true)
  //   setShowRejectModal(true)
  //   handleAcceptExpediteDeferRequests(
  //     setRequestData,
  //     selectedRowArray,
  //     setSubmitting,
  //     setShowRejectModal
  //   )
  //   closeDivertAcceptModal()
  // }
  const handleAcceptRequest = () => {
    setSubmitting(true)
    setShowRejectModal(true)

    handleAcceptExpediteDeferRequests(
      updateDataCount,
      setRequestData,
      selectedRowArray,
      setSubmitting,
      setShowRejectModal,
      // setStopUpdating,
      (success, data) => {
        if (success) {
          if (data) {
            const crIdResponse = data.map((item) => item.id_open_request)
            const poRow = data.map((item) => item.po_number)
            setCrIdResponse(crIdResponse)
            setPoRow(poRow)
          }
          setShowChangeRequestBanner(true)
          fetchAllRequests()
          updateDataCount(user?.supplierId)
        }
      }
    )

    closeDivertAcceptModal()
    // fetchAllRequests()
    // setShowChangeRequestBanner(true)
  }
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.updated) {
        fetchAllRequests(); // Refresh data when the popup sends an update
        updateDataCount(user?.supplierId)
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);
  const fetchAllRequests = () => {
    setLoading(true)
    axiosInstance
      .get(
        `/api/get-supplier-cr-type-data?vendorNumber=${user?.supplierId}&crType=DIVERT`,
        // ValidateAPI()
      )
      .then((response) => {

        if (response?.data?.[0]?.Message) return setRequestData([])
        setRequestData(response?.data)
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false);
        console.error(error)
        if (error.response.status === 401 || error.response.status === 403) {
          navigate('/login-error')
        }
      })
  }

  useEffect(() => {
    fetchAllRequests()
  }, [showChangeRequestBanner, showRejectRequestBanner])

  useEffect(() => {
    const handleClickOutside = () => {
      setShowChangeRequestBanner(false)
      setShowRejectRequestBanner(false)
    }
    if (showChangeRequestBanner || showRejectRequestBanner) {
      window.addEventListener('click', handleClickOutside)
    }
    return () => {
      window.removeEventListener('click', handleClickOutside)
    }
  }, [showChangeRequestBanner, showRejectRequestBanner])

  useEffect(() => {
    if (selectedRowArray?.length > 0) {
      setValidSw(false); // Hide the error message as soon as an order is selected
    }
  }, [selectedRowArray]);

  const [additionalReasonForOther, setadditionalReasonForOther] = useState("")
  const changeOtherReason = (e) => {
    setadditionalReasonForOther(e.target.value)
    // setErrorMessage('')
  }

  return (
    <div className='w-full flex flex-col gap-6 justify-start items-start p-4'>
      <div className='w-full justify-between flex items-center'>
        <div className=''>
          <p className='text-xl'>{DivertRequests}</p>
        </div>
        {/* <UserProfile /> */}
      </div>
      <div className='w-full text-xs flex justify-start items-center gap-1 font-medium text-gray-600'>
        <p className='flex gap-1 items-center justify-center'>
          <span
            className='hover:underline cursor-pointer'
            onClick={() => navigate('/vendor')}
          >
            {Home}
          </span>
          <span>{'>'}</span>
        </p>
        <p className='flex gap-1 items-center justify-center'>
          <span>{DivertRequests}</span>
        </p>
      </div>

      <div>
        <div className='flex w-full justify-start items-center font-medium text-xs gap-3'>
          <button
            className='px-3 rounded-md bg-green-500 text-white h-[32px]'
            onClick={() => {
              if (selectedRowArray?.length > 0) {
                openDivertAcceptModal()
                setValidSw(false)
              } else {
                setValidSw(true)
              }
            }}

          >
            <span>
              {selectedRowArray?.length > 1 ? t('DivertPage.Accept') : t('DivertPage.Accept')}
            </span>
          </button>

          <PopupModal
            isOpen={showDivertAcceptModal}
            message={i18next.t('PopUpMessage.Doyouwanttoaccepttheserequests')}
            onCancel={closeDivertAcceptModal}
            cancelText={i18next.t('AcceptModal.Cancel')}
            onConfirm={handleAcceptRequest}
            confirmText={i18next.t('AcceptModal.Confirm')}
          />

          <button disabled={reasonCodeValue?.reasonCodeText === 'Other' && additionalReasonForOther.length === 0}
            className='px-3 rounded-md bg-red-500 text-white h-[32px]'
            onClick={() => {
              if (selectedRowArray?.length > 0) {
                setShowRejectModal(true)
                setValidSw(false)
              } else {
                setValidSw(true)
              }
            }}

          >
            {selectedRowArray?.length > 1 ? t('DivertPage.Reject') : t('DivertPage.Reject')}
          </button>
        </div>
        {validSw && (
          <p className='text-red-500 text-xs mt-2'>{PleaseSelectaPO}</p>
        )}
      </div>

      {loading ? (
        <div className='w-full min-h-[300px] flex justify-center items-center'>
          <Loading />
        </div>
      ) : (
        <div className='w-full overflow-x-auto'>
          <ConfirmTable
            tableId={tableId}
            tableData={requestData}
            columns={columns}
            selection={setSelectedRowArray}
            updateRowSelectionProp={setRowSelection}
            rowSelectionProp={rowSelection}
          />
        </div>
      )}
      <dialog
        open={showRejectModal}
        className='p-3 inset-0 fixed z-70 bg-black bg-opacity-50 w-full min-h-screen'
      >
        <div className='w-full min-h-screen p-4 flex justify-center items-center'>
          {submitting ? (
            <div className='sm:w-[400px] w-[280px] bg-white p-4 rounded-md flex flex-col gap-6'>
              <Loading type={Submitting_Load} />
            </div>
          ) : (
            <div className='sm:w-[400px] w-[280px] bg-white p-4 rounded-md flex flex-col gap-6'>
              <div className='w-full flex justify-end items-center'>
                <button
                  className='border-2 border-gray-300 p-2 rounded-md'
                  onClick={() => {
                    setShowRejectModal(false)
                    setErrorMessage('')
                    setreasonCodeValue({
                      "reasonCodeId": "",
                      "reasonCodeText": ""
                    })
                  }}
                >
                  ❌
                </button>
              </div>
              <div className='w-full flex justify-center items-center mt-2 text-center'>
                <p className='text-sm font-medium'>
                  {Pleaseselectreasoncodeforrejectingtheorder}
                </p>
              </div>
              {/* This is to show reasonCodeValue once user selected from list  */}
              <ReasonCodeView
                reasonCodeValue={reasonCodeValue}
                setreasonCodeValue={setreasonCodeValue}
              />
              {/* View End */}

              {/*  ReasonCode List Component to view all list and select*/}
              <ReasonCodeList
                reasonCodeValue={reasonCodeValue}
                setreasonCodeValue={setreasonCodeValue}
                 type='Divert'
                 setErrorMessage={setErrorMessage} 
                 setReasonMessage={setadditionalReasonForOther}
                 />
             {reasonCodeValue?.reasonCodeText === "Others" && <div className="w-full flex flex-col">
                  <CommonReasonTextarea
                    value={additionalReasonForOther}
                    error={errorMessage}
                    onChange={changeOtherReason}
                    setErrorMessage={setErrorMessage}
                  />
                </div>}
              {/* End Component */}
              <div className='w-full flex justify-center items-center gap-4 mt-4'>
                <button
                
                className={`text-xs font-medium w-[80px] rounded-md h-[38px] text-white bg-red-500 outline-none ${errorMessage ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                }`}                  
                disabled={errorMessage}
                 onClick={() => {
                    if (reasonCodeValue?.reasonCodeText === "Others" && (!additionalReasonForOther || additionalReasonForOther.trim().length === 0)) {
                      setErrorMessage('Message is required');
                    } else{
                      handleRejectExpediteDeferDivertRequest(
                        additionalReasonForOther,
                        updateDataCount,
                        setRequestData,
                        selectedRowArray,
                        reasonCodeValue,
                        setShowRejectModal,
                        setreasonCodeValue,
                        setSubmitting, (success, data) => {
                          if (success) {
                            if (data) {
                              const editCrIdResponse = data.map(
                                (item) => item.id_open_request
                              )
                              const editPoRow = data.map((item) => item.po_number)
                              setEditPORow(editPoRow)
                              setEditCrIdResponse(editCrIdResponse)
                            }
                            setShowRejectRequestBanner(true)
                            fetchAllRequests()
                            updateDataCount(user?.supplierId)
                          }
                        }
                      )
                    }       
                  }}
                >
                  {Reject}
                </button>
                {/* <PopupBanner
        isOpen={showRejectRequestBanner}
               
        message={"Orders Rejected  successfully"}
        onCancel={closePopUpModal}
        text={poRow}
        text1={crIdResponse}
      /> */}
                <button
                  className='text-xs font-medium w-[80px] rounded-md h-[38px] text-white bg-gray-500 outline-none'
                  onClick={() => {
                    setShowRejectModal(false)
                    setErrorMessage('');
                    setreasonCodeValue({
                      "reasonCodeId": "",
                      "reasonCodeText": ""
                    })
                  }}
                >
                  {Cancel}
                </button>
              </div>
            </div>
          )}
        </div>
      </dialog>
      <PopupBanner
        isOpen={showChangeRequestBanner}
        message={'Divert Orders Submitted Successfully'}
        onCancel={closePopUpModal}
        text={poRow}
        text1={crIdResponse}
      />
      <PopupBanner
        isOpen={showRejectRequestBanner}
        message={'Divert Requests Rejected  Successfully'}
        onCancel={closePopUpModal}
        text={editPoRow}
        text1={editCrIdResponse}
      />
    </div>
  )
}

export default Divert
